/*
 * MDB shim for MDBCard
 * Files currently importing this symbol from "mdbreact":
 * - src/Components/Custom/InformationChangeModal.jsx
 * - src/Components/Pipeline/MonthGlance.jsx
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Orders/ATPView.jsx
 * - src/Seating/Patient/PatientViewComponents/HomeAssessmentModal.jsx
 * - src/Seating/Patient/PatientViewComponents/attachmentsTab.jsx
 * - src/Seating/Patient/PatientViewComponents/notesTab.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PresidentsClub/presidentsClubView.jsx
 * - src/Seating/PurchaseQueue/ShippingDetailsReport.jsx
 * - src/Seating/Reports/dailyOrderCounts.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/productTypes.jsx
 */

import MUICard from "@mui/material/Card";

export default function MDBCard({ children, className, style, ...rest }) {
    return (
        <MUICard className={className} style={style} {...rest}>
            {children}
        </MUICard>
    );
}
